<template>
  <v-app>
    <!-- <v-dialog v-model="isIdle" width="60%"> -->
    <!-- <v-card v-if="isIdle">
        <v-card-title
          class="headline font-weight-regular blue-grey white--text"
          primary-title
        >
          Session Expired
        </v-card-title>

        <v-divider></v-divider> -->

    <ModalIdle v-if="isIdle"></ModalIdle>
    <!-- </v-card> -->
    <!-- </v-dialog> -->
    <router-view/>
  </v-app>
</template>

<script>
import ModalIdle from "../src/sharedComponents/ModalIdle";
import {LOGOUT} from "@/store/actions.type";

export default {
  name: "App",
  components: {
    ModalIdle,
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
  },
  created() {
    const expirationTime = localStorage.getItem('expirationTime') ?? null;
    if (expirationTime == null || Date.now() > expirationTime) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.logout();
    }
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        this.$router.push("/login");
      });
    },
  },


};
</script>
